import React from 'react';
import { useFlowWebContext } from '../FlowWebProvider';
import { LightText } from '../Text';
import { useTranslate } from '../util';
import { StyledBar, StyledBarContainer, StyledBarWrapper, StyledBottomInfo, StyledBottomText, StyledInlinePercent, StyledTopInfo } from './ProgressBar.styled';
export function ProgressBar(_ref) {
  var _ref$disableAnimation = _ref.disableAnimation,
    disableAnimation = _ref$disableAnimation === void 0 ? false : _ref$disableAnimation,
    _ref$forceLargeVersio = _ref.forceLargeVersion,
    forceLargeVersion = _ref$forceLargeVersio === void 0 ? false : _ref$forceLargeVersio,
    label = _ref.label,
    percent = _ref.percent,
    progressText = _ref.progressText,
    _ref$showPercent = _ref.showPercent,
    showPercent = _ref$showPercent === void 0 ? true : _ref$showPercent,
    timeEstimate = _ref.timeEstimate,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 300 : _ref$width,
    barColor = _ref.barColor;
  var t = useTranslate();
  var _useFlowWebContext = useFlowWebContext(),
    language = _useFlowWebContext.language;
  var boundedPercent = Math.min(percent || 0, 100);
  var formattedPercent = boundedPercent.toLocaleString(language);
  var style = {
    width: "".concat(boundedPercent.toFixed(2), "%")
  };
  var showBottomInformation = !!(progressText || timeEstimate);
  var isSmallVersion = !label && !showBottomInformation && !forceLargeVersion;
  var showTopInformation = !isSmallVersion && (!!label || showPercent);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: width
    }
  }, showTopInformation && /*#__PURE__*/React.createElement(StyledTopInfo, null, /*#__PURE__*/React.createElement(LightText, null, !!label && label), /*#__PURE__*/React.createElement(LightText, {
    textAlign: "right"
  }, showPercent && t('citrix-ui:percent', {
    percent: formattedPercent
  }))), /*#__PURE__*/React.createElement(StyledBarContainer, null, /*#__PURE__*/React.createElement(StyledBarWrapper, null, /*#__PURE__*/React.createElement(StyledBar, {
    style: style,
    shouldAnimate: !disableAnimation,
    barColor: barColor
  })), isSmallVersion && showPercent && /*#__PURE__*/React.createElement(StyledInlinePercent, null, /*#__PURE__*/React.createElement(LightText, null, t('citrix-ui:percent', {
    percent: formattedPercent
  })))), showBottomInformation && /*#__PURE__*/React.createElement(StyledBottomInfo, null, /*#__PURE__*/React.createElement(StyledBottomText, null, !!progressText && progressText), /*#__PURE__*/React.createElement(StyledBottomText, {
    textAlign: "right"
  }, !!timeEstimate && timeEstimate)));
}